<template>
    <div>
        <template>
            <h2>カード検索</h2>
            <v-container>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-form class="mt-2">
                            <v-text-field v-model="card_name" @change="not_registerd = false" label="カード名" clearable></v-text-field>
                            <v-select v-model="card_color" :items="color" @change="not_registerd = false" label="色" clearable></v-select>
                            <v-select v-model="card_lot" :items="lot" @change="not_registerd = false" label="収録弾" clearable></v-select>
                            <v-checkbox v-model="is_psa" label="PSAカード"></v-checkbox>
                            <v-btn color="primary" elevation="2" @click="searchCard" min-width="180">検索する</v-btn>
                        </v-form>
                    </v-col>

                    <v-col cols="12" md="6"  class="d-flex flex-row justify-center">
                        <div v-if="not_registerd">
                            <div>この検索条件に該当するカードはありません</div>
                            <v-btn
                                color="primary"
                                elevation="2"
                                min-width="180"
                                @click="goRegisterCard"
                            >この条件でカードを登録する</v-btn>
                        </div>

                        <v-col v-if="card_selected" cols="12" sm="12" lg="6" xl="4" class="text-center">
                            <v-card>
                                <v-img :src="url_prefix + selected_card.image"></v-img>
                            </v-card>
                        </v-col>
                    </v-col>
                </v-row>
            </v-container>

            <v-divider class="mt-2 mb-6"></v-divider>

            <v-btn color="primary" elevation="2" class="mb-2" @click="view_table = !view_table">リスト表示/画像表示を切り替える</v-btn>
            <v-container v-if="!view_table">
                <v-row class="mt-4">
                    <v-col v-for="(card, i) in cards" :key="i" cols="12" sm="6" lg="3" xl="2" class="text-center">
                        <v-card>
                            <v-img :src="url_prefix + card.image"></v-img>
                            <div class="pa-3">
                                <div>{{ card.card_name }}</div>
                                <div>{{ card.color }}</div>
                                <div>
                                    {{ card.lot }}
                                    <v-chip
                                        v-if="card.is_psa"
                                        color="red"
                                        dark
                                    >
                                        PSAカード
                                    </v-chip>
                                </div>
                            </div>
                            <v-card-actions>
                                <v-list-item class="grow">
                                    <v-row
                                    align="center"
                                    justify="center"
                                    >
                                        <v-btn
                                            class="mr-1"
                                            color="primary"
                                            @click="goEditCard(card.id)"
                                        >
                                            編集
                                        </v-btn>
                                        <v-btn
                                            class="ml-1"
                                            color="primary"
                                            @click="goRegisterEntry(card.id, card.image, card.card_name, card.color, card.lot)"
                                        >
                                            買取登録
                                        </v-btn>
                                    </v-row>
                                </v-list-item>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>

            <v-data-table
                v-if="view_table"
                :headers="headers"
                :items="cards"
                class="elevation-1"
                no-data-text="データはありません"
                @click:row="clickRow"
            >
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                            @click="goEditCard(item.id)"
                            >
                            mdi-pencil
                            </v-icon>
                        </template>
                        <span>カードデータを編集する</span>
                        
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                            @click="goRegisterEntry(item.id, item.image, item.card_name, item.color, item.lot)"
                            >
                            mdi-card-plus-outline
                            </v-icon>
                        </template>
                        <span>買取データを登録する</span>

                    </v-tooltip>

                </template>
            </v-data-table>
        </template>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            view_table: true,
            not_registerd: false,
            card_selected: false,
            selected_card: null,
            card_name: null,
            card_color: null,
            card_lot: null,
            is_psa: false,
            color: ['赤', '緑', '青', '紫', '黄', '黒'],
            lot: [
                'ブースターパック 新時代の主役 [OP-05]',
                'ブースターパック 謀略の王国 [OP-04]',
                'スタートデッキ ゾロ&サンジ [ST-12]',
                'スタートデッキ Side ウタ [ST-11]',
                'アルティメットデッキ"三船長"集結 [ST-10]',
                '限定商品収録カード',
                'プレミアムブースター ONE PIECE CARD THE BEST【PRB-01】',
                'エクストラブースター メモリアルコレクション【EB-01】',
                'ブースターパック 二つの伝説【OP-08】',
                'ブースターパック 500年後の未来【OP-07】',
                'ブースターパック 双璧の覇者【OP-06】',
                'ブースターパック 強大な敵【OP-03】',
                'ブースターパック 頂上決戦【OP-02】',
                'ブースターパック ROMANCE DAWN【OP-01】',
                'スタートデッキ 黄 シャーロット・カタクリ【ST-20】',
                'スタートデッキ 黒 スモーカー【ST-19】',
                'スタートデッキ 紫 モンキー・D・ルフィ【ST-18】',
                'スタートデッキ 青 ドンキホーテ・ドフラミンゴ【ST-17】',
                'スタートデッキ 緑 ウタ【ST-16】',
                'スタートデッキ 赤 エドワード・ニューゲート【ST-15】',
                'スタートデッキ 3D2Y【ST-14】',
                'アルティメットデッキ 3兄弟の絆【ST-13】',
                'スタートデッキ Side ヤマト【ST-09】',
                'スタートデッキ Side モンキー・D・ルフィ【ST-08】',
                'スタートデッキ ビッグ・マム海賊団【ST-07】',
                'スタートデッキ 海軍【ST-06】',
                'スタートデッキ ONE PIECE FILM edition【ST-05】',
                'スタートデッキ 百獣海賊団【ST-04】',
                'スタートデッキ 王下七武海【ST-03】',
                'スタートデッキ 最悪の世代【ST-02】',
                'スタートデッキ 麦わらの一味【ST-01】',
                'ファミリーデッキセット',
                'プロモーションカード',
            ],
            headers: [
                { text: 'カード名', value: 'card_name' },
                { text: '色', value: 'color' },
                { text: '収録弾', value: 'lot' },
                { text: '登録アカウント', value: 'registered_account.store_name' },
                { value: 'actions' },
            ],
            cards: [],
            url_prefix: "",
        }
    },
    methods: {
        searchCard() {
            this.card_selected = false
            var params = {}
            if(this.card_name || this.card_color || this.card_lot || this.is_psa) {
                if(this.card_name){
                    params.card_name = this.card_name
                }
                if(this.card_color){
                    params.card_color = this.card_color
                }
                if(this.card_lot){
                    params.card_lot = this.card_lot
                }
                if(this.is_psa){
                    params.is_psa = this.is_psa
                }
                this.axios
                .get(`${process.env.VUE_APP_API_ORIGIN}/card/search`, {
                    params
                })
                .then(res => {
                    this.cards = res.data
                    if(!this.cards[0]) {
                        this.not_registerd = true
                        this.card_selected = false
                    }
                })
                .catch(() => {
                    alert(e)
                })
            } else {
                alert('検索条件を入力してください')
            }
        },
        goRegisterCard() {
            this.$router.push({
                name: 'RegisterCard',
                params: {
                    card_name: this.card_name,
                    card_color: this.card_color,
                    card_lot: this.card_lot
                }
            })
        },
        goEditCard(card_id) {
            this.$router.push({
                name: 'EditCard',
                params: {
                    card_id: card_id,
                }
            })
        },
        goRegisterEntry(card_id, card_image, card_name, card_color, card_lot) {
            this.$router.push({
                name: 'RegisterEntry',
                params: {
                    card_id: card_id,
                    card_image: card_image,
                    card_name: card_name,
                    card_color: card_color,
                    card_lot: card_lot
                }
            })
        },
        clickRow(row) {
            this.card_selected = true
            this.selected_card = row
        }
    },
    mounted: function () {
        this.url_prefix = `${process.env.VUE_APP_API_ORIGIN}`
    }
}
</script>

<style>
.v-data-table tr:hover td {
    background-color: #eee;
}
</style>
